<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        clearable
        style="width: 200px"
        class="filter-item"
        placeholder="姓名/手机号"
        v-model="listQuery.name"
      >
      </el-input>
      <!-- <el-input clearable style="width: 200px;" class="filter-item" placeholder="销服账号" v-model="listQuery.siebelId">
      </el-input> -->
      <el-cascader
        class="filter-item"
        style="width: 350px"
        placeholder="选择经销商"
        filterable
        change-on-select
        :show-all-levels="false"
        :options="dealerOptions"
        v-model="listQuery.dealerCode"
      >
      </el-cascader>
      <el-select
        style="width: 150px"
        class="filter-item"
        v-model="listQuery.activeStatus"
      >
        <el-option label="全部" :value="99"> </el-option>
        <el-option label="未激活" :value="0"> </el-option>
        <el-option label="已激活" :value="1"> </el-option>
      </el-select>
      <el-select
        style="width: 150px"
        class="filter-item"
        v-model="listQuery.status"
      >
        <el-option label="全部状态" :value="99"> </el-option>
        <el-option label="正常" :value="0"> </el-option>
        <el-option label="离职" :value="1"> </el-option>
        <el-option label="禁用" :value="-1"> </el-option>
      </el-select>
      <el-select
        style="width: 150px"
        class="filter-item"
        v-if="businessType === 0"
        v-model="listQuery.dealerType"
      >
        <el-option label="商家类型" :value="99"></el-option>
        <el-option label="对公" :value="6"></el-option>
      </el-select>
      <el-button
        class="filter-item"
        type="info"
        icon="el-icon-search"
        @click="doSearch"
        >搜索</el-button
      >
      <el-button class="filter-item" icon="el-icon-refresh" @click="doReset"
        >重置</el-button
      >
      <el-button class="filter-item" icon="el-icon-download" @click="doExport"
        >导出</el-button
      >
      <!-- <el-button class="filter-item" icon="el-icon-upload2" @click="showImportDialog">证书导入</el-button> -->
      <!-- <el-button
        class="filter-item"
        icon="el-icon-upload2"
        @click="showImportDialog2"
        >成员导入</el-button
      > -->
    </div>

    <el-table
      :data="list"
      v-loading="listLoading"
      fit
      border
      highlight-current-row
      style="width: 100%"
      max-height="600"
    >
      <el-table-column align="left" label="姓名" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.userName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="手机号" width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.mobile }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="身份证号" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.identify }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="商家类型" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.dealerType | dealerTypeDisplay }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="经销商名称" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.dealerName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="系统角色" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.roleName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="人管角色" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.dems_role }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="加入时间" width="140">
        <template slot-scope="scope">
          <span>{{
            scope.row.joinDate | parseTime("{y}-{m}-{d} {h}:{i}")
          }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="离职时间" width="140">
        <template slot-scope="scope">
          <span v-if="scope.row.leaveDate > 0">{{
            scope.row.leaveDate | parseTime("{y}-{m}-{d} {h}:{i}")
          }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column align="center" label="证书" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.haveCert === 1 ? '是' : '否' }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="销服账号" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.siebelId }}</span>
        </template>
      </el-table-column> -->
      <el-table-column align="left" label="接收线上线索" width="100">
        <template slot-scope="scope">
          <span>{{
            scope.row.role === 15 || scope.row.role === 16
              ? "打开"
              : scope.row.onlineOrder
              ? "打开"
              : "关闭"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="是否激活" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.isActive ? "已激活" : "未激活" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        align="center"
        label="状态"
        width="100"
      >
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | statusFilter">{{
            scope.row.status | statusDisplay
          }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status != 1"
            size="mini"
            @click="showResetDialog(scope.row)"
            >重置密码</el-button>
          <el-button
            v-if="scope.row.status !== 1 && isSuper"
            size="mini"
            @click="showViewDialog(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>


    <el-dialog title="重置密码" :visible.sync="resetDialog" width="500px">
      <el-form
        ref="editForm"
        :model="editData"
        :rules="resetPwdRules"
        label-position="right"
        label-width="120px"
      >
        <el-form-item label="姓名">
          {{ editData.userName }}
        </el-form-item>
        <el-form-item label="手机号">
          <Desensitize
            :text="editData.mobile"
            :dataType="1"
            :userId="editData.userId"
            :clearText="true"
            :userType="2"
          />
        </el-form-item>
        <el-form-item label="经销商名称">
          {{ editData.dealerName }}
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input style="width: 120px" v-model="newPassword"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetDialog = false">取消</el-button>
        <el-button type="primary" @click="doResetPassword">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="证书导入" :visible.sync="importDialogVisible" width="30%">
      <div style="text-align: center">
        <el-upload
          class="upload-demo"
          accept=".xlsx"
          drag
          action
          :file-list="uploadFiles"
          :http-request="uploadRequest"
          :limit="1"
          :on-success="uploadSuccess"
          :on-remove="uploadRemove"
          :before-upload="uploadBefore"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">只能上传excel文件</div>
        </el-upload>
        <div>
          <a
            href="https://zhizhu-high.oss-cn-shenzhen.aliyuncs.com/zhizhu/v2/temp/template/%E7%94%A8%E6%88%B7%E8%AF%81%E4%B9%A6%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx"
            class="table-href"
            >下载模版</a
          >
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="hideImportDialog">取消</el-button>
        <el-button type="primary" :loading="uploadLoading" @click="doImport"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="成员导入"
      :visible.sync="importDialogVisible2"
      width="30%"
    >
      <div style="text-align: center">
        <el-upload
          class="upload-demo"
          accept=".xlsx"
          drag
          action
          :file-list="uploadFiles2"
          :limit="1"
          :http-request="uploadRequest"
          :on-success="uploadSuccess2"
          :on-remove="uploadRemove2"
          :before-upload="uploadBefore"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">只能上传excel文件</div>
        </el-upload>
        <div>
          <a
            href="https://duigongzhizhu-oss-test.oss-cn-shenzhen.aliyuncs.com/public/%E7%BB%8F%E9%94%80%E5%95%86%E6%88%90%E5%91%98%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx"
            class="table-href"
            >下载模版</a
          >
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="hideImportDialog2">取消</el-button>
        <el-button type="primary" :loading="uploadLoading" @click="doImport2"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <!-- 编辑 -->
    <EditUser :visible.sync="editDialog" :formData="formData" @editSuccess="doSearch"/>
  </div>
</template>

<script>
import store from "@/store";
import axios from "axios";
import oss from "@/utils/ali-oss";
import EditUser from "./components/EditUser.vue"
import { deepClone } from '@/utils/index'
var dealerUsersVm;
export default {
  name: "DealerApproveList",
  components: { EditUser },
  data() {
    dealerUsersVm = this;
    return {
      businessType: store.getters.user.businessType,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        status: 99,
        activeStatus: 99,
        siebelId: "",
        name: "",
        dealerCode: [],
        dealerType: 99,
      },
      roles: [],
      isSuper: store.getters.user.isSuper,
      dealerOptions: [],
      memberRoles: [],
      // importSources: [],
      formData: {},
      editDialog: false,
      editData: {},

      resetDialog: false,
      importDialogVisible: false,
      importDialogVisible2: false,
      uploadLoading: false,
      uploadFiles: [],
      uploadFile: "",
      uploadFiles2: [],
      uploadFile2: "",
      roles1: [],
      roles2: [],
      newPassword: "",
      resetPwdRules: Object.freeze({
        newPassword: [
          {
            validator: (rule, value, callback) => {
              const passwordPattern =
                /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W _]).{8,}$/;
              if (!passwordPattern.test(this.newPassword)) {
                callback(
                  new Error("大小写字母+数字+特殊字符三种组合，长度最小8")
                );
              } else {
                callback(); // 校验通过
              }
            },
            trigger: "blur",
          },
        ],
      }),
    };
  },
  filters: {
    dealerTypeDisplay(type) {
      const map = {
        1: "王朝",
        2: "海洋",
        6: "对公",
      };
      return map[type];
    },
    statusFilter(status) {
      const statusMap = {
        0: "success",
        1: "warning",
        "-1": "info",
      };
      return statusMap[status + ""];
    },
    statusDisplay(status) {
      const statusMap = {
        0: "正常",
        1: "离职",
        "-1": "禁用",
      };
      return statusMap[status + ""];
    },
  },
  beforeRouteEnter(to, from, next) {
    next();
  },
  activated() {
    if (this.$route.meta.hasOwnProperty("redraw") && this.$route.meta.redraw) {
      this.doReset();
      this.$route.meta.redraw = false;
    }
    if (
      this.$route.meta.hasOwnProperty("refresh") &&
      this.$route.meta.refresh
    ) {
      this.getList();
      this.$route.meta.refresh = false;
    }
  },
  created() {
    this.doReset();
    this.retrieveDealerOptions();
    this.getRoles();
  },
  methods: {
    allRolesDisplay(allRows) {
      return (allRows + "")
        .split(",")
        .map((e) => this.roleDisplay(+e))
        .join("、");
    },
    roleDisplay(role) {
      for (var i = 0; i < dealerUsersVm.memberRoles.length; i++) {
        var o = dealerUsersVm.memberRoles[i];
        if (o.dataValue == role) {
          return o.dataDisplay;
        }
      }
      return "";
    },
    getRoles() {
      axios
        .all([this.getRoles1(), this.getRoles2()])
        .then(
          axios.spread((a, b) => {
            var roles = [];
            this.roles1.forEach((item) => {
              if (
                this.roles2
                  .map((item) => item.dataValue)
                  .indexOf(item.dataValue) < 0
              ) {
                roles.push(item);
              }
            });
            this.memberRoles = [...this.roles2, ...roles];
          })
        )
        .catch((err) => {
          console.log(err.response);
        });
    },
    getRoles1() {
      var parent = this;
      return this.$httpAuth
        .post("v1/backendDictionaryRpc/list", {
          pageStart: 0,
          pageCount: 99,
          status: 99,
          category: "DEALER_MEMBER_ROLE_2",
          name: "",
        })
        .then(function (response) {
          parent.roles1 = response.data.data;
        });
    },
    getRoles2() {
      var parent = this;
      return this.$httpAuth
        .post("v1/backendDictionaryRpc/list", {
          pageStart: 0,
          pageCount: 99,
          status: 99,
          category: "DEALER_MEMBER_ROLE_TS",
          name: "",
        })
        .then(function (response) {
          parent.roles2 = response.data.data;
        });
    },
    doReset() {
      this.list = [];
      this.total = 0;
      this.listLoading = true;
      this.listQuery = {
        page: 1,
        limit: 10,
        status: 99,
        activeStatus: 99,
        siebelId: "",
        name: "",
        dealerCode: [],
        dealerType: 99,
      };
      this.doSearch();
    },
    doSearch() {
      this.listQuery.page = 1;
      this.getList();
    },
    retrieveDealerOptions() {
      var parent = this;
      this.$httpAuth
        .post("/v1/backendDealerRpc/jsonTree", {})
        .then(function (response) {
          parent.dealerOptions = response.data.data;
          parent.dealerOptions.unshift({
            label: "全部",
            level: 1,
            value: "",
          });
        });
    },
    getList() {
      this.listLoading = true;
      var parent = this;
      var dealerCode = "";
      var dealerBigArea = "";
      var dealerSalesCenter = "";
      var dealerProvince = "";
      var dealerCity = "";
      if (this.listQuery.dealerCode.length == 5) {
        dealerCode = this.listQuery.dealerCode[4];
      }
      if (this.listQuery.dealerCode.length == 1) {
        dealerSalesCenter = this.listQuery.dealerCode[0];
      }
      if (this.listQuery.dealerCode.length == 2) {
        dealerSalesCenter = this.listQuery.dealerCode[0];
        dealerBigArea = this.listQuery.dealerCode[1];
      }
      if (this.listQuery.dealerCode.length == 3) {
        dealerSalesCenter = this.listQuery.dealerCode[0];
        dealerBigArea = this.listQuery.dealerCode[1];
        dealerProvince = this.listQuery.dealerCode[2];
      }
      if (this.listQuery.dealerCode.length == 4) {
        dealerSalesCenter = this.listQuery.dealerCode[0];
        dealerBigArea = this.listQuery.dealerCode[1];
        dealerProvince = this.listQuery.dealerCode[2];
        dealerCity = this.listQuery.dealerCode[3];
      }
      this.$httpAuth
        .post("/v1/backendDealerRpc/userList", {
          pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
          pageCount: this.listQuery.limit,
          status: this.listQuery.status,
          activeStatus: this.listQuery.activeStatus,
          name: this.listQuery.name,
          dealerCode: dealerCode,
          dealerBigArea: dealerBigArea,
          dealerSalesCenter: dealerSalesCenter,
          dealerProvince: dealerProvince,
          dealerCity: dealerCity,
          siebelId: this.listQuery.siebelId,
          dealerType: this.listQuery.dealerType,
        })
        .then(function (response) {
          parent.listLoading = false;
          parent.list = response.data.data;
          parent.total = response.data.total;
        })
        .catch(() => {
          parent.listLoading = false;
        });
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    showViewDialog(row) {
      this.formData = deepClone(row);
      // this.formData.allRoles = this.allRolesDisplay(this.formData.allRoles)
      this.editDialog = true;
    },

    showResetDialog(row) {
      this.editData = JSON.parse(JSON.stringify(row));
      this.resetDialog = true;
      this.newPassword = "";
    },
    doResetPassword() {
      var parent = this;
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$httpAuth
            .post("/v1/backendDealerRpc/resetPassword", {
              userId: this.editData.userId,
              password: this.newPassword,
            })
            .then(function (response) {
              parent.resetDialog = false;
              parent.$message({
                message: "密码重置成功",
                type: "success",
              });
            })
            .catch(() => {});
        }
      });
    },
    doExport() {
      const loading = this.$loading({
        lock: true,
        text: "正在导出中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      var parent = this;
      var dealerCode = "";
      var dealerBigArea = "";
      var dealerSalesCenter = "";
      var dealerProvince = "";
      var dealerCity = "";
      if (this.listQuery.dealerCode.length == 5) {
        dealerCode = this.listQuery.dealerCode[4];
      }
      if (this.listQuery.dealerCode.length == 1) {
        dealerSalesCenter = this.listQuery.dealerCode[0];
      }
      if (this.listQuery.dealerCode.length == 2) {
        dealerSalesCenter = this.listQuery.dealerCode[0];
        dealerBigArea = this.listQuery.dealerCode[1];
      }
      if (this.listQuery.dealerCode.length == 3) {
        dealerSalesCenter = this.listQuery.dealerCode[0];
        dealerBigArea = this.listQuery.dealerCode[1];
        dealerProvince = this.listQuery.dealerCode[2];
      }
      if (this.listQuery.dealerCode.length == 4) {
        dealerSalesCenter = this.listQuery.dealerCode[0];
        dealerBigArea = this.listQuery.dealerCode[1];
        dealerProvince = this.listQuery.dealerCode[2];
        dealerCity = this.listQuery.dealerCode[3];
      }

      this.$httpAuth
        .post("/v1/backendDealerRpc/userList", {
          pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
          pageCount: this.listQuery.limit,
          status: this.listQuery.status,
          activeStatus: this.listQuery.activeStatus,
          name: this.listQuery.name,
          dealerCode: dealerCode,
          dealerBigArea: dealerBigArea,
          dealerSalesCenter: dealerSalesCenter,
          dealerProvince: dealerProvince,
          dealerCity: dealerCity,
          siebelId: this.listQuery.siebelId,
          dealerType: this.listQuery.dealerType,
          isExport: true,
        })
        .then(function (response) {
          console.log(response.data);
          setTimeout(() => {
            loading.close();
            var a = document.createElement("a");
            a.href = response.data.file;
            a.click();
          }, 1000);
        })
        .catch(() => {
          loading.close();
        });
    },
    showImportDialog() {
      this.importDialogVisible = true;
      this.uploadLoading = false;
    },
    hideImportDialog() {
      this.uploadFiles = [];
      this.uploadFile = "";
      this.importSource = "";
      this.importDialogVisible = false;
      this.syncDialogVisible = false;
    },
    showImportDialog2() {
      this.importDialogVisible2 = true;
      this.uploadLoading = false;
    },
    hideImportDialog2() {
      this.uploadFiles2 = [];
      this.uploadFile2 = "";
      this.importDialogVisible2 = false;
    },

    uploadBefore(file) {
      if (
        file.type !=
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        this.$message.error("请上传xlsx格式文件!");
        return false;
      }
    },

    uploadSuccess(res, file) {
      this.uploadFile = res;
    },
    uploadSuccess2(res, file) {
      this.uploadFile2 = res;
    },
    uploadRequest(option) {
      oss.ossUploadFile(option);
    },
    uploadRemove(file, fileList) {
      this.uploadFile = "";
    },
    uploadRemove2(file, fileList) {
      this.uploadFile2 = "";
    },

    doImport() {
      if (this.uploadFile === "") {
        this.$message({
          message: "请选择导入文件",
          type: "warning",
        });
        return;
      }
      var parent = this;
      parent.uploadLoading = true;
      this.$httpAuth
        .post("/v1/backendDealerRpc/userCertImport", {
          fileUrl: this.uploadFile,
        })
        .then(function (res) {
          if (res.data.success) {
            parent.$message({
              message: "导入成功",
              type: "success",
            });
            parent.uploadLoading = false;
            parent.hideImportDialog();
            parent.doReset();
          }
        })
        .catch(function (error) {
          parent.uploadLoading = false;
          return;
        });
    },
    doImport2() {
      if (this.uploadFile2 === "") {
        this.$message({
          message: "请选择导入文件",
          type: "warning",
        });
        return;
      }
      var parent = this;
      parent.uploadLoading = true;
      this.$httpAuth
        .post("/v1/backendDealerRpc/userImport", {
          fileUrl: this.uploadFile2,
        })
        .then(function (res) {
          if (res.data.success) {
            parent.$message({
              message: "导入成功",
              type: "success",
            });
            parent.uploadLoading = false;
            parent.hideImportDialog2();
            parent.doReset();
          }
        })
        .catch(function (error) {
          parent.uploadLoading = false;
          return;
        });
    },
  },
};
</script>
